<template>
  <div id="app">

    <!-- NavBar导航栏 -->
    <!-- <div v-show="nextPath != 'index'">
      <van-nav-bar
        class="navbar"
        :title="title"
        :left-arrow="(nextPath == 'index' || nextPath == 'custom' || nextPath == 'mine') ? false : true"
        :right-text="rightText"
        @click-left="onClickLeft"
        @click-right="onClickRight"
        v-show="nextPath != 'login'"
        fixed
        placeholder
      />
    </div> -->

    <keep-alive>
      <!-- 路由 -->
      <router-view />
    </keep-alive>

    <!-- 底部导航 -->
    <div v-show="(nextPath == 'index' || nextPath == 'custom' || nextPath == 'mine')">
      <van-tabbar 
        route 
        fixed
        placeholder
        class="tabbar"
        >
        <van-tabbar-item replace to="/">
          <span>首页</span>
          <template #icon="props">
            <img :src="props.active ? indexIcon.active : indexIcon.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/custom">
          <span>客户</span>
          <template #icon="props">
            <img :src="props.active ? customIcon.active : customIcon.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/mine">
          <span>我的</span>
          <template #icon="props">
            <img :src="props.active ? mineIcon.active : mineIcon.inactive" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { NavBar,Tabbar,TabbarItem } from 'vant';

export default {
  name: 'App',
  data:function(){
    return {
      indexIcon:{
        active:require('./assets/icon-tab-index-active.png'),
        inactive:require('./assets/icon-tab-index-inactive.png')
      },
      customIcon:{
        active:require('./assets/icon-tab-custom-active.png'),
        inactive:require('./assets/icon-tab-custom-inactive.png')
      },
      mineIcon:{
        active:require('./assets/icon-tab-mine-active.png'),
        inactive:require('./assets/icon-tab-mine-inactive.png')
      },
    }
  },
  components: {
    [NavBar.name]:NavBar,
    [Tabbar.name]:Tabbar,
    [TabbarItem.name]:TabbarItem  
  },
  methods:{
    onClickLeft(){
      // 点击了返回
      this.$router.go(-1);
    },
    onClickRight(){
      //点击了右侧
    }
  },
  computed:{
    nextPath(){
      return this.$store.state.nextPath;
    },
    title(){
      return this.$store.state.nextTitle;
    },
    rightText(){
      return (this.$store.state.nextPath == 'stock-manage') ? '库存明细' : ''
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.navbar,.tabbar{
  height:46px!important;
}
</style>
